module.exports = __webpack_public_path__ + "img/16.7670c52e.png";